
const token = localStorage.getItem('token');
const tokentype = localStorage.getItem('token_type');

const AuthHeader = {  
    header:{  
        'Authorization' : `${tokentype} ${token}`
    },
    gettoke:token,
}

export default AuthHeader;